import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X, ArrowLeft } from 'lucide-react';

interface MobileSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  showHandle?: boolean;
  fullScreen?: boolean;
}

const MobileSheet: React.FC<MobileSheetProps> = ({
  isOpen,
  onClose,
  title,
  children,
  showHandle = true,
  fullScreen = false,
}) => {
  // Prevent body scroll when sheet is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  // Portal to document.body so the sheet escapes any stacking context
  // created by overflow / -webkit-overflow-scrolling on ancestor elements.
  return createPortal(
    <>
      {/* Overlay */}
      <div 
        className={`mobile-sheet-overlay ${isOpen ? 'open' : ''}`}
        onClick={onClose}
      />

      {/* Sheet */}
      <div 
        className={`mobile-sheet ${isOpen ? 'open' : ''}`}
        style={fullScreen ? { 
          top: 0,
          maxHeight: 'none',
          borderRadius: 0,
          overflow: 'hidden',
        } : {}}
      >
        {showHandle && !fullScreen && <div className="mobile-sheet-handle" />}
        
        {title && (
          <div
            className="mobile-sheet-header"
            style={fullScreen ? {
              paddingTop: 'calc(16px + env(safe-area-inset-top, 0px))',
              flexShrink: 0,
            } : undefined}
          >
            {fullScreen && (
              <button
                className="mobile-sheet-close"
                onClick={onClose}
                style={{ marginRight: 8 }}
              >
                <ArrowLeft size={20} />
              </button>
            )}
            <h2 className="mobile-sheet-title" style={{ flex: 1 }}>{title}</h2>
            {!fullScreen && (
              <button className="mobile-sheet-close" onClick={onClose}>
                <X size={18} />
              </button>
            )}
          </div>
        )}

        <div className="mobile-sheet-content">
          {children}
        </div>
      </div>
    </>,
    document.body
  );
};

export default MobileSheet;
